<template>
  <div>
    <add-campaign-modal :is-active.sync="isAdding" @added="campaignAdded" />
    <data-table
      title="Campaigns"
      ref="table"
      :url="url"
      :csv="true"
      :headers="headers"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Campaign
        </v-btn>
      </template>
      <template slot="item.is_active" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
        <v-icon color="warning" v-else>mdi-information-outline</v-icon>
      </template>
      <template slot="item.is_the_default" slot-scope="{ item }">
        <span v-if="item.is_the_default">Yes</span>
        <span v-else>No</span>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCampaignModal from "./campaignForm";

export default {
  components: { AddCampaignModal },
  data() {
    return {
      isAdding: false,
      currentFilter: "all",
      url: "api/v1/campaigns",
      headers: this.pairTableLabelWithValue({
        ID: "id",
        "Campaign Name": "name",
        "Target Users": "target_users",
        "Compensation Type": "compensation_type",
        "Referrer Compensation": "referrer_compensation_value",
        "Referrer Offer": "referrer_offer_label",
        "Referred Compensation": "referred_compensation_value",
        "Referred Offer": "referred_offer_label",
        "Start Date": "start_date",
        "End Date": "end_date",
        "Is Active": "is_active",
        "Is Default": "is_the_default",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "campaigns.show", params: { id } });
    },
    campaignAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
  },
};
</script>
